import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";


import useTable from "../components/useTable2.js";
import { TableBody, TableRow, TableCell } from "@mui/material";

import { Mensaje } from "../components/mensajes";
import axios from "axios";
import {Dimmer} from "../components/spinner";

const CatalogoProvFondoTer = (props) => {
  let op = require("../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const btnCancela = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({});
  const [activo, setActivo] = useState(true);
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    {
      id: "responsable",
      label: "CEDULA/RIF",
      width: "10px",
      textAlign: "center",
      backgroundColor: "rgb(5, 81, 130)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "razonsocial",
      label: "NOMBRE",
      width: "300px",
      textAlign: "center",
      backgroundColor: "rgb(5, 81, 130)",
      fontSize: "10px",
      color: "white",
    },
    /*    { id: 'accion', label: '', width: '120px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
     */
  ];
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.responsable.includes(target.value) ||
              x.razonsocial.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const seleccionarRegistros = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "proveedor";
    let nomid = "idproveedor";
    let condi = "fondotercero";
    let orden = 'idproveedor';

    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&id=${idefiscal}&nomtab=${nomtab}&nomid=${nomid}&condi=${condi}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          console.log(response.data);
          setRecords(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
    setItemSelect("");
    setActivo(true);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const seleccionarCatProgramatica = () => {
  

    blanquear();
    props.onHideAceptaCatalogo(values.idproveedor);
   
  };

  const seleccionarFila = (index) => (e) => {
    e.preventDefault();
    setItemSelect(index);
    setActivo(false);
  
    setValues(recordsAfterPagingAndSorting()[index]);
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="lg"
      backdrop="static"
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      keyboard={false}
      onShow={() => {
        seleccionarRegistros();
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>
          Seleccionar Proveedor.
        </h3>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} >
        </Dimmer>
        <div className="input-group input-group-sm mb-3 m-0 col-5">
          <input type="text"
            onChange={handleSearch}
            className="form-control rounded-pill"/>
        </div>
        <div className="col-12 p-0 m-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={item.idproveedor}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "10px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.responsable}
                    </td>
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "300px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.razonsocial}
                    </td>
                    {/* <td align="center" style={{ fontSize: "10px", textAlign: "center", width: "120px", padding: 0, verticalAlign: "middle" }}>
                                            <button style={{ width: "120px" }} onClick={seleccionarProveedors(index)} className="btn btn-outline-info"><i className="fas fa-edit">Seleccionar</i> </button>
                                        </td> */}
                  </tr>
                ))}
            </tbody>{" "}
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer className="footer-azulGradiant">
        <button className="btn btn-sm btn-success rounded-pill col-md-2"
          disabled={activo}
          onClick={seleccionarCatProgramatica}>
          Aceptar <i className="fas fa-check-circle"> </i>{" "}
        </button>
        <button ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill text-light col-md-2">
          Cancelar <i className="fas fa-window-close"> </i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoProvFondoTer;
